import React from "react";
import { formatDate3 } from "winslow-core";

interface ResourceOwnerProps {
  avatarUrl: string | null;
  firstName: string;
  lastName: string;
  createdAt: Date;
}

export const ResourceOwner: React.FC<ResourceOwnerProps> = ({
  avatarUrl,
  firstName,
  lastName,
  createdAt,
}) => {
  return (
    <div className="collection-resources-owner">
      <div className="collection-resources-avatar">
        <img src={avatarUrl || ""} alt="" />
      </div>
      <div className="collection-resources-name">
        {firstName + " " + lastName}
      </div>
      <div className="collection-resources-date">
        &middot;&nbsp;&nbsp;
        {formatDate3(new Date(createdAt))}
      </div>
    </div>
  );
};
